import { render } from "./NuevoTicket.modal.vue?vue&type=template&id=44c6826a"
import script from "./NuevoTicket.modal.vue?vue&type=script&lang=js"
export * from "./NuevoTicket.modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__